import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { SessionService } from "../shared/services/session.service";
import { Observable } from "rxjs";
import { AuthService } from "@auth0/auth0-angular";
import { inject } from "@angular/core";
import { GolfTechType } from "../shared/models/golftech-type.enum";


  export const SimulatorBookingAuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
  Observable<boolean | UrlTree> 
  | Promise<boolean | UrlTree> 
  | boolean 
  | UrlTree=> {

    const sessionService = inject(SessionService);
    const router = inject(Router)
    const auth0 = inject(AuthService);

    if (sessionService.getUser().golfTechType === GolfTechType.Simulator || sessionService.getUser().golfTechType === GolfTechType.GlobalAdmin) {
      return true;
    } else {
      return router.parseUrl('/login');
    }
  }